export default player => {
  player.on('ready', () => {
    if (!player?.config?.logo || player?.config?.logo_added) {
      return;
    }
    if (player.isAudio) return;

    const controlsElement = player?.elements?.controls;
    if (!controlsElement || !controlsElement.parentNode) {
      return;
    }

    // Use the controls' own document so the logo is created in the iframe
    // editor's document (WP 7.0) and not the parent window's.
    const logoImage = controlsElement.ownerDocument.createElement('img');
    logoImage.src = player?.config?.logo;
    logoImage.className = 'presto-player__logo is-bottom-right';
    logoImage.setAttribute('part', 'logo');

    controlsElement.parentNode.insertBefore(logoImage, controlsElement);

    player.config.logo_added = true;
  });
};
